var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProducingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2C3 2.69036 2.44036 3.25 1.75 3.25C1.05964 3.25 0.5 2.69036 0.5 2C0.5 1.30964 1.05964 0.75 1.75 0.75C2.44036 0.75 3 1.30964 3 2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 2C9.25 2.69036 8.69036 3.25 8 3.25C7.30964 3.25 6.75 2.69036 6.75 2C6.75 1.30964 7.30964 0.75 8 0.75C8.69036 0.75 9.25 1.30964 9.25 2Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 2C15.5 2.69036 14.9404 3.25 14.25 3.25C13.5596 3.25 13 2.69036 13 2C13 1.30964 13.5596 0.75 14.25 0.75C14.9404 0.75 15.5 1.30964 15.5 2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducingIcon);
export default __webpack_public_path__ + "static/media/producingIcon.35b1c3b74606d888f61897e497ebd01a.svg";
export { ForwardRef as ReactComponent };